<script setup></script>

<template>
  <div class="references">
    <h3>References 🔎</h3>
    <p>
      I have worked for 2 agencies in NZ. The latter being Pocket Square for 7+
      years. I am currently freelancing abroad and will be back in NZ from 01
      November, 2025.
    </p>
    <div class="references__block">
      <h4>Pocket Square</h4>
      <p><strong>Job Title:</strong> Senior Frontend Technical Lead</p>
      <p><strong>Date:</strong> June 2017 - July 2025</p>
      <p>
        <strong>Responsibilities:</strong> Scoping and leading projects,
        building frameworks, day-to-day operations, running wips, conducting
        interviews.
      </p>
      <p>
        <strong>Contact: </strong>
        <a href="mailto:lance@pocketsquare.co.nz">lance@pocketsquare.co.nz</a>
      </p>
    </div>
    <div class="references__block">
      <h4>Zyber</h4>
      <p><strong>Job Title:</strong> Backend Developer</p>
      <p><strong>Date:</strong> May 2016 - Dec 2017</p>
      <p>
        <strong>Responsibilities:</strong> Building apps for Shopify app store,
        JavaScript lead developer.
      </p>
    </div>
    <div class="references__block">
      <h4>Freelancing</h4>
      <p><strong>Job Title:</strong> Contractor</p>
      <p>
        <strong>Responsibilities:</strong> Automative apps and Shopify client
        work.
      </p>
    </div>
  </div>
</template>

<style lang="scss">
.references {
  &__block {
    h4 {
      margin-block: 2rem 1rem;
    }
  }

  p {
    font-family: monospace;
    color: var(--white);
  }
}
</style>
